import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild, Input } from '@angular/core';
import { Colours } from '../../common/common.types';
import { StripeService, USStripeService } from '../stripe.service';
import { StripeCard } from '../stripe.types';

@Component({
	selector: 'azc-stripe-card',
	template: `
	<div class="stripeCard mat-form-field">
		<label for="stripeCardElement">
			Credit or Debit Card
		</label>
		<div class="stripeInput" #stripeCard></div>
		<div *ngIf="error" class="mat-form-field-subscript-wrapper">
			<div class="mat-error" role="alert">{{error}}</div>
		</div>
	</div>`,
	styles: [`
		.stripeCard {
			display: block;
			position: relative;
			border-top: 0.84375em solid transparent;
			min-width: 26rem;
			padding-bottom: 1.25em;
		}
		label {
			font-size: 1.4rem;
			position: absolute;
			top: -0.84375em;
			color: rgba(0, 0, 0, 0.54);
			transform-origin: 0 0;
			transform: scale(0.75) perspective(100px);
		}
		.stripeInput {
			padding-top: calc(0.4375em - 1px);
			border-bottom: 1px solid rgba(0, 0, 0, 0.42);
			padding-bottom: calc(0.4375em - 1px);
		}
		.stripeInput--focus {
			border-bottom-width: 2px;
			border-bottom-color: ${Colours.primary};
			padding-bottom: calc(0.4375em - 2px);
		}
		.stripeInput--invalid {
			border-bottom-color: ${Colours.error};
		}
		.mat-form-field-subscript-wrapper {
			position: absolute;
		}
	`]
})
export class AzcStripeCardComponent implements AfterViewInit {
	@Input() private currencyCode: string;
	@Output() private onChange = new EventEmitter<stripe.elements.ElementChangeResponse>();
	@ViewChild('stripeCard') stripeRef: ElementRef;
	private stripeCard: StripeCard;
	public error: string;

	constructor(private _ss: StripeService, private _uss: USStripeService) { }

	async ngAfterViewInit() {
		this.stripeCard = await this._ss.getCard(this.stripeRef);

		// FIXME: Not sure if this is gonna work or worth to add card to the US
		// since we do not know the location
		// if (this.stripeCard) {
		if (this.currencyCode && this.currencyCode.toLowerCase() === 'usd') {
			this.stripeCard = await this._uss.getCard(this.stripeRef);
		}

		this.stripeCard.onChange.subscribe(({ error }) => {
			this.error = error ? error.message : null;
		});

		this.stripeCard.onChange.subscribe(x => this.onChange.emit(x));
	}

	public async createToken(options?: stripe.TokenOptions): Promise<stripe.TokenResponse> {
		return this.stripeCard.createToken(options);
	}
}
